import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { MyProfilePage } from './my-profile.page';
import { LoggedInGuard } from '../core/guards/logged-in.guard';
import { AngularPhoneUtilsLibModule } from 'angular-phone-utils-lib';

const routes: Routes = [
  {
    path: '',
    component: MyProfilePage
  },
  {
    path: 'osebni-podatki',
    loadChildren: () => import('./personal-data/personal-data.module').then( m => m.PersonalDataPageModule)
  },
  {
    path: 'privolitve',
    loadChildren: () => import('./consents/consents.module').then( m => m.ConsentsPageModule)
  },
  { path: 'moje-rezervacije', canActivate: [ LoggedInGuard ], loadChildren: () => import('./my-bookings/my-bookings.module').then(m => m.MyBookingsPageModule) },
  { path: 'moje-rezervacije/:bookingId', canActivate: [ LoggedInGuard ], loadChildren: () => import('./my-bookings/booking-detail/booking-detail.module').then(m => m.BookingDetailPageModule) },

];

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    AngularPhoneUtilsLibModule
  ],
  declarations: [MyProfilePage]
})
export class MyProfilePageModule {}
